var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "0 10px" } },
    [
      _c(
        "el-table",
        {
          staticClass: "table-height",
          attrs: {
            data: _vm.logTableData,
            border: "",
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            height: _vm.height,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "80",
              fixed: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operationType",
              label: _vm.$t("collectionCenter.operationType"),
              "min-width": "160",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operationType === 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v(_vm._s(_vm.$t("mdfeTranslate.Authorized"))),
                        ])
                      : scope.row.operationType === 2
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v(_vm._s(_vm.$t("GlobalSetObj.Canceled"))),
                        ])
                      : scope.row.operationType === 3
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v(_vm._s(_vm.$t("mdfeTranslate.Closed"))),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: _vm.$t("GlobalSetObj.status"),
              "min-width": "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v(_vm._s(_vm.$t("GlobalSetObj.succeed"))),
                        ])
                      : scope.row.status === 2
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v(_vm._s(_vm.$t("GlobalSetObj.Lose"))),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "vehiclePlate",
              label: _vm.$t("seller.licensePlateNumber"),
              "min-width": "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.transportInfo.vehiclePlate,
                    function (item, index) {
                      return _c("div", { key: index }, [_vm._v(_vm._s(item))])
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createUserStr",
              label: _vm.$t("GlobalSetObj.operator"),
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updateTime",
              label: _vm.$t("GlobalSetObj.operationTime"),
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: _vm.$t("collectionCenter.Note"),
              "min-width": "180",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.queryForm.pageNumber,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.queryForm.pageSize,
              total: _vm.total,
              background: "",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.getCurrentTable,
              "size-change": _vm.getSizeTable,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }